import axios from 'axios';

export default {
    namespaced: true,
    state: {
        addresses: null,
        user: null,
        loadingAccountInfo: false
    },
    mutations: {
        loadAccountInfo(state) {
            state.loadingAccountInfo = true;
        },
        resetAccountInfo(state) {
            state.addresses = null;
            state.user = null;
        },
        updateUser(state, user) {
            state.user = user;
        },
        updateAddress(state, address) {
            state.addresses = address;
            state.loadingAccountInfo = false;
        }
    },
    actions: {
        getAccountInfo({ commit, dispatch }) {
            commit('resetAccountInfo');
            commit('loadAccountInfo');
            dispatch('getAddressInfo');
            axios
                .get('/user')
                .then(result => {
                    commit('updateUser', result.data.data);
                })
                .catch(console.error);
        },
        getAddressInfo({ commit }) {
            axios
                .get('/addresses')
                .then(result => {
                    commit('updateAddress', result.data);
                })
                .catch(console.error);
        },
        postAccountInfo({ state }) {
            axios
                .post('/user', {
                    userData: state.user,
                    addresses: state.addresses
                })
                .catch(console.error);
        }
    }
};
